import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './fonts/NotoSans/NotoSans-Italic.ttf';
import './fonts/NotoSans/NotoSans-Regular.ttf';
import './fonts/NotoSans/NotoSans-Light.ttf';
import './fonts/NotoSans/NotoSans-LightItalic.ttf';
import './fonts/NotoSans/NotoSans-Medium.ttf';
import './fonts/NotoSans/NotoSans-MediumItalic.ttf';
import './fonts/NotoSans/NotoSans-Bold.ttf';
import './fonts/NotoSans/NotoSans-BoldItalic.ttf';
import './fonts/NotoSans/NotoSans-SemiBold.ttf';
import './fonts/NotoSans/NotoSans-SemiBoldItalic.ttf';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
